export default "__VITE_ASSET__l4EjM4Za__"